// PAGE LINES — each page's one-line description, under its name in the
// section column. Nucleus's own preference (it changes only Nucleus), kept in
// this browser and stamped on the document for the CSS (Layout.css).
const KEY = 'nucleus:page-lines';
const ATTR = 'data-nx-page-lines';

export function readPageLines() {
    try { return localStorage.getItem(KEY) === 'off' ? 'off' : 'on'; } catch { return 'on'; }
}

export function applyPageLines(value = readPageLines()) {
    if (typeof document !== 'undefined') document.documentElement.setAttribute(ATTR, value);
}

export function setPageLines(value) {
    try { localStorage.setItem(KEY, value); } catch { /* private mode */ }
    applyPageLines(value);
}
